import moment from 'moment';
import React, { useEffect, useState } from 'react';
import CanvasJSReact from '../../../assets/js/canvasjs.react';
import * as _ from 'lodash';
import WeekModal from '../common/WeekModal';
import { fetchChartData } from '../../../services/dashboard';
import { DateModal } from '../common/DateModal';
import DateAndWeekModal from '../common/DateAndWeekModal';
var CanvasJS:any = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

export const ProviderProduction = ({ clinicId }: any) => {
    const [dataPoints, setDataPoints] = useState([{ label: 'Provider 1', y: 5 }, { label: 'Provider 2', y: 10 }, { label: 'Provider 3', y: 15 }, { label: 'Provider 4', y: 8 }, { label: 'Provider 5', y: 11 }, { label: 'Provider 6', y: 5 }, { label: 'Provider 7', y: 13 }]);
    const [productionData, setProductionData]: any = useState('');
    const [isShowNoData, setIsShowNoData] = useState(false);
    const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
    const [startDate, setStartDate] = useState(moment().subtract(6, 'days').format('YYYY-MM-DD'));
    const [isDateChange, setIsDateChange] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    let controller: any;
    useEffect(() => {
        if (clinicId) {
            controller = new AbortController();
            setTimeout(() => {
                fetchData();
            }, 1000);
        }
        return () => {
            if (controller) {
                controller.abort()
            }
        }
    }, [startDate, endDate, clinicId]);
    
    const fetchData = () => {
        setIsLoading(true);
        fetchChartData('providerwiseproduction', clinicId, startDate, endDate,controller)
            .then((success) => {
                setIsLoading(false);
                if (success && success.providerWiseProduction.length > 0) {
                    setProductionData(
                        success.providerWiseProduction.map((item: any) => {
                            return { label: item.fullname, y: Number(item.total), production: Math.round(Number(item.production)), timeSpent: Number(item.timeSpent) }
                        })
                    )
                    setIsShowNoData(false);
                } else {
                    setIsShowNoData(true);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log('error while fetching data - schedule', error);
            })
    }
    const handleDateChange = (sDate: any, eDate: any) => {
        setStartDate(sDate);
        setEndDate(eDate);
        setIsDateChange(false)
    }

    useEffect(() => {
        if (productionData && productionData.length > 0) {
            let options = {
                animationEnabled: true,
                theme: "light2",
                // title: {
                //     text: "Provider Production"
                // },
                axisY: {
                    title: "Appointments",
                },
                axisX: {
                    interval: 1
                },
                data: [{
                    type: "bar",
                    indexLabel: "${production}",
                    indexLabelFontColor: "#EEEEdE",
                    indexLabelPlacement: "inside",
                    indexLabelFontWeight: "bold",
                    // markerSize: '8',
                    dataPoints: productionData
                }]
            }
            var charts = new CanvasJS.Chart("providerproduction", options);
            charts.render();
        }
    }, [productionData]);
    return (
        <div className="col-4 mb-4">
            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <div className='d-flex flex-row'>
                        <h6 className="m-0">Provider Production</h6> &nbsp;
                        <span>({moment(startDate).format('MMM DD')+" - "+moment(endDate).format('MMM DD')})</span>
                    </div>
                    <div>
                        <button type="button" className="btn p-1" onClick={() => { setIsDateChange(true) }}><i className="bi bi-calendar-week"></i></button>
                        {/* <button type="button" className="btn p-1"><i className="bi bi-info-circle"></i></button> */}
                    </div>
                </div>
                <div className="card-body" style={{height:'290px'}}>
                    {
                        (isLoading) ?
                            <div className="mt-5 loder_in rounded text-center">
                                <div className="spinner-border align-items-center" role="status">
                                </div>
                                <div className="mt-2">Loading...</div>
                            </div>
                            :
                            <>
                                <div className="graph-area" style={{ height: '100%',width:'100%' }}>
                                    {/* <img src={require("../../../assets/images/chart/Production.png")} alt='image not found' /> */}
                                    {
                                        productionData.length === 0 &&
                                        <div>No Record found.</div>
                                    }
                                    <div className='w-100 h-100' id="providerproduction"></div>
                                </div>
                            </>
                    }
                </div>
            </div>
            {
                (isDateChange) &&
                <DateAndWeekModal
                    show={isDateChange}
                    handleClose={() => { setIsDateChange(false) }}
                    handleDateChange={(sDate: any, eDate: any) => { handleDateChange(sDate, eDate) }}
                />
            }
        </div>
    )
}